import React, { Suspense } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

// Importing pages
import AdminLoginPage from './pages/auth/AdminLoginPage';
import AdminDashboard from './pages/admin/Dashboard/Dashboard';
import AdminNutritions from './pages/admin/Nutritions/Nutritions';
import AdminTrainings from './pages/admin/Trainings/Trainings';
import AdminUsers from './pages/admin/Users/Users';
import AdminVideos from './pages/admin/Videos/Videos';
import AdminChangePasswordPage from './pages/admin/ChangePassword/ChangePassword';
import AdminPaymentsList from './pages/admin/Payments/Payments';
import AdminEnquiriesList from './pages/admin/Enquiries/Enquiries';

import MealPlan from './pages/customer/MealPlan/MealPlan';
import MealPlanNew from './pages/customer/MealPlan/MealPlanNew';


import AddMeal from './pages/customer/MealPlan/AddMeal';
import CustomizeMeal from './pages/customer/MealPlan/CustomizeMeal';

import CustomerConfiguration from './pages/customer/Configuration/Configuration';

import CustomerStepTracker from './pages/customer/ProgressTracker/StepTracker';
import CustomerWeightTracker from './pages/customer/ProgressTracker/WeightTracker';
import PreviousWeeksAverageWeights from './pages/customer/ProgressTracker/PreviousWeeksAverageWeights';
import PreviousWeeksAverageSteps from './pages/customer/ProgressTracker/PreviousWeeksAverageSteps';

import FavouriteMealPlans from './pages/customer/MealPlan/FavouriteMealPlans';
import CustomerRecipes from './pages/customer/Recipes/Recipes';
import CustomerRecipeDetail from './pages/customer/Recipes/RecipeDetail';

import CustomerVideos from './pages/customer/Videos/Videos';
import CustomerPaymentsPage from './pages/customer/Payments/Payments';
import CustomerRefersPage from './pages/customer/Refers/Refers';
import CustomerPreviousTrainingPrograms from './pages/customer/Training/PreviousTrainingPrograms';
import CustomerTrainingPage from './pages/customer/Training/TrainingPage';

import CustomerLoginPage from './pages/auth/CustomerLoginPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import VerifyOtp from './pages/auth/VerifyOtp'; // This is the component for /verify-top
import ResetPassword from './pages/auth/ResetPassword';

import ChangePasswordPage from './pages/customer/ChangePassword/ChangePassword';
import AdminConfiguration from './pages/admin/Configuration/Configuration';
import ProfilePage from './pages/customer/Profile/Profile';

import AdminProfilePage from './pages/admin/Profile/Profile';
import AdminPolicyPage from './pages/admin/Policy/Policy';
import AdminTermsPage from './pages/admin/Policy/TermsAndConditions';
import AdminManageMealsIngredients from './pages/admin/Nutritions/CustomizeMeal';

import ProtectedRoute from './ProtectedRoute';

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* Admin routes */}
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute allowedUserType="admin"><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/nutrition" element={<ProtectedRoute allowedUserType="admin"><AdminNutritions /></ProtectedRoute>} />
        <Route path="/admin/profile" element={<ProtectedRoute allowedUserType="admin"><AdminProfilePage /></ProtectedRoute>} />
        <Route path="/admin/nutrition" element={<ProtectedRoute allowedUserType="admin"><AdminNutritions /></ProtectedRoute>} />

        <Route path="/admin/manage-ingredients/:mealId" element={<ProtectedRoute allowedUserType="admin"><AdminManageMealsIngredients /></ProtectedRoute>} />
        
        <Route path="/admin/training" element={<ProtectedRoute allowedUserType="admin"><AdminTrainings /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute allowedUserType="admin"><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/videos" element={<ProtectedRoute allowedUserType="admin"><AdminVideos /></ProtectedRoute>} />
        <Route path="/admin/change-password" element={<ProtectedRoute allowedUserType="admin"><AdminChangePasswordPage /></ProtectedRoute>} />
        <Route path="/admin/privacy-policy" element={<ProtectedRoute allowedUserType="admin"><AdminPolicyPage /></ProtectedRoute>} />
        <Route path="/admin/terms-and-conditions" element={<ProtectedRoute allowedUserType="admin"><AdminTermsPage /></ProtectedRoute>} />
        <Route path="/admin/configuration" element={<ProtectedRoute allowedUserType="admin"><AdminConfiguration /></ProtectedRoute>} />
        <Route path="/admin/payments-list" element={<ProtectedRoute allowedUserType="admin"><AdminPaymentsList /></ProtectedRoute>} />
        <Route path="/admin/enquiries-list" element={<ProtectedRoute allowedUserType="admin"><AdminEnquiriesList /></ProtectedRoute>} />

        {/* Customer routes */}
        <Route path="/login" element={<CustomerLoginPage />} />
        <Route path="/" element={<CustomerLoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Additional customer routes */}
        <Route path="/meal-plan" element={<ProtectedRoute allowedUserType="client"><MealPlan /></ProtectedRoute>} />
        <Route path="/meal-plan-new" element={<ProtectedRoute allowedUserType="client"><MealPlanNew /></ProtectedRoute>} />
        <Route path="/add-meal/:category_url" element={<ProtectedRoute allowedUserType="client"><AddMeal /></ProtectedRoute>} />
        <Route path="/customize-meal/:mealId" element={<ProtectedRoute allowedUserType="client"><CustomizeMeal /></ProtectedRoute>} />

        <Route path="/configuration" element={<ProtectedRoute allowedUserType="client"><CustomerConfiguration /></ProtectedRoute>} />
        <Route path="/weight-tracker" element={<ProtectedRoute allowedUserType="client"><CustomerWeightTracker /></ProtectedRoute>} />
        <Route path="/step-tracker" element={<ProtectedRoute allowedUserType="client"><CustomerStepTracker /></ProtectedRoute>} />
        <Route path="/previous-weeks-average-weights" element={<ProtectedRoute allowedUserType="client"><PreviousWeeksAverageWeights /></ProtectedRoute>} />
        <Route path="/previous-weeks-average-steps" element={<ProtectedRoute allowedUserType="client"><PreviousWeeksAverageSteps /></ProtectedRoute>} />
        <Route path="/favourite-meal-plans" element={<ProtectedRoute allowedUserType="client"><FavouriteMealPlans /></ProtectedRoute>} />
        <Route path="/recipes/:category" element={<ProtectedRoute allowedUserType="client"><CustomerRecipes /></ProtectedRoute>} />
        <Route path="/recipe-detail/:category/:recipeId" element={<ProtectedRoute allowedUserType="client"><CustomerRecipeDetail /></ProtectedRoute>} />
        <Route path="/get-started" element={<ProtectedRoute allowedUserType="client"><CustomerVideos /></ProtectedRoute>} />
        <Route path="/previous-training-programs" element={<ProtectedRoute allowedUserType="client"><CustomerPreviousTrainingPrograms /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute allowedUserType="client"><ChangePasswordPage /></ProtectedRoute>} />
   
        <Route path="/profile" element={<ProtectedRoute allowedUserType="client"><ProfilePage /></ProtectedRoute>} />
        <Route path="/training" element={<ProtectedRoute allowedUserType="client"><CustomerTrainingPage /></ProtectedRoute>} />
        <Route path="/subscription" element={<ProtectedRoute allowedUserType="client"><CustomerPaymentsPage /></ProtectedRoute>} />
        <Route path="/invite-user" element={<ProtectedRoute allowedUserType="client"><CustomerRefersPage /></ProtectedRoute>} />
        
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;